import { TS_ExtraNights }       from '../TravelSeller/Models/TS_ExtraNights';
import { BookingItemInterface } from './BookingItemInterface';

export class ExtraNights extends TS_ExtraNights implements BookingItemInterface {
}
